import React from 'react';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function AdminSection({ title, description, icon: Icon, action, children, className = '' }) {
  const tc = useThemeClasses();

  return (
    <section className={`rounded-2xl border overflow-hidden ${tc.box} ${className}`}>
      {(title || action) && (
        <div
          className={`px-4 py-3 border-b flex flex-wrap items-start justify-between gap-2 ${
            tc.modoOscuro ? 'border-gray-800 bg-gray-900/40' : 'border-gray-100 bg-gray-50/80'
          }`}
        >
          <div className="flex items-start gap-3 min-w-0">
            {Icon ? (
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                  tc.modoOscuro ? 'bg-gray-800 text-white' : 'bg-gray-900 text-white'
                }`}
              >
                <Icon className="w-4 h-4" />
              </div>
            ) : null}
            <div className="min-w-0">
              {title ? <h2 className={`text-sm font-semibold ${tc.textPri}`}>{title}</h2> : null}
              {description ? <p className={`text-xs mt-0.5 ${tc.textSec}`}>{description}</p> : null}
            </div>
          </div>
          {action ? <div className="shrink-0">{action}</div> : null}
        </div>
      )}
      <div className="p-4">{children}</div>
    </section>
  );
}
